import React from "react";
import "../style/DateTimeRange.scss";
import { InputGroup, FormControl } from "react-bootstrap";
import PropTypes from "prop-types";
import { darkTheme, lightTheme } from "../utils/StyleUtils";

class DateField extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeDateTextHandler = this.onChangeDateTextHandler.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onChangeDateTextHandler(event) {
    this.props.onChangeDateTextHandlerCallback(
      event.target.value,
      this.props.mode
    );
  }

  onBlur() {
    this.props.dateTextFieldCallback(this.props.mode);
  }

  onClick() {
    // console.log("datalabel checkeing checker", this.props.dateLabel);
    if (this.props.mode === "start") {
      this.props.changeSelectingModeCallback(true);
    } else {
      this.props.changeSelectingModeCallback(false);
    }
  }

  formatDate = (dateTimeString) => {
    if (typeof dateTimeString !== "string") {
      return "Invalid input";
    }
  
    const [date, time] = dateTimeString.split(" ");
    if (!date || !time) {
      return "Invalid input";
    }
  
    const [day, month, year] = date.split("-");
    const [hours, minutes] = time.split(":");
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedDateTime = `${year}/${month}/${day} ${formattedHours}:${minutes} ${amPm}`;
    
    return formattedDateTime;
  };

  render() {
    let theme = this.props.darkMode ? darkTheme : lightTheme;

    const formattedDate = this.formatDate(this.props.dateLabel);

    return (
      <>
        <FormControl
          className="inputDate"
          id={"DateTimeInput_" + this.props.mode}
          // style={theme}
          style={{ ...theme, outline: "none" }}
          type="text"
          value={formattedDate}
          readOnly
          onChange={this.onChangeDateTextHandler}
          onBlur={this.onBlur}
        />
        </>
    );
  }
}

DateField.propTypes = {
  changeSelectingModeCallback: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  dateLabel: PropTypes.string.isRequired,
  dateTextFieldCallback: PropTypes.func.isRequired,
  onChangeDateTextHandlerCallback: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};
export default DateField;
